module.exports = __webpack_public_path__ + "static/img/streamMedia-whyneed-img4.f230011.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/streamMedia-whyneed-img4.png
// module id = 1097
// module chunks = 1